export enum PriceAdjustmentType {
	NotSet = 0,
    Percent = 3
}



// WEBPACK FOOTER //
// ./src/app/models/price-adjustment-type.enum.ts